import { DownOutlined } from '@ant-design/icons'
import { Dropdown, Menu, PageHeader } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import routes from '@/constants/routes'

const MachinesPageHeader = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const menu = (
    <Menu>
      <Menu.Item key="1" onClick={() => navigate({ pathname: routes.importMachines.path, search: `is_insert=true` })}>
        {t('components.pages.machines.list.pageHeader.import')}
      </Menu.Item>
      <Menu.Item key="2" onClick={() => navigate({ pathname: routes.importTankToMachines.path })}>
        {t('components.pages.machines.list.pageHeader.importTank')}
      </Menu.Item>
    </Menu>
  )

  return (
    <PageHeader
      ghost={false}
      title={t('components.pages.machines.list.pageHeader.title')}
      extra={[
        <>
          <Dropdown.Button
            key="action"
            type="primary"
            icon={<DownOutlined />}
            overlay={menu}
            onClick={() => navigate(routes.createMachine.path)}
          >
            {t('components.pages.employees.list.pageHeader.new')}
          </Dropdown.Button>
        </>,
      ]}
    />
  )
}

MachinesPageHeader.displayName = 'MachinesPageHeader'
export default MachinesPageHeader
